import { render, staticRenderFns } from "./ScrollDownButton.vue?vue&type=template&id=ab55f982"
import script from "./ScrollDownButton.vue?vue&type=script&lang=js"
export * from "./ScrollDownButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArrowDownIcon: require('/vercel/path0/components/icons/ArrowDownIcon.vue').default})
